/* @flow */

export function getChallenges({ intelligence_id, language }: Object) {
  return {
    type: 'REQUEST_CHALLENGES',
    payload: {
      intelligence_id,
      language
    }
  };
}
 